module.exports = __webpack_public_path__ + "img/logo.85d35daf.png";